module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAABVklEQVQokZXST0tVURQF8N+9vjLFMLVBGDYQiqCgzxCcj+Cs2RvUsKn0LUKIiEAcBA7CSdDkXIKahEEQBDUx0TQTFRFMe/3x2eDuB2+QZgsOZ50De+299t5FzvkObmETh06GAkN43sBdTGDlhMEdjGCugbcppQ//GQy7VVW9LHLO83iBH2ihT22lhTNR7vcu3sJpNHCzxHksYh0X8QWrwTewjFFsYwkXsBsxQyVe4zcOsIM99AT/Fpn3Q+BU8JWo5F2JWTwKkYeRYRT3w8oYptGLcczgJx7jVZFzbuISnuE2Pkc/rmMypbT+tw5WVTWFtRJtDKCJBczhSVRy75gpDKJdxqMXW5hPKX3E5RD4dIwA6Ah0NrA/7iZu4Ou/BBrq7ndOO/4f4EpUcRTaOChxFsM4F1xK6Q3eh8hRGMZgkXN+qp7CL/WCbIWlq+pxLXZZ7c5+DWt/AOCSYwSVppA3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/47.png
// module id = rJ4P
// module chunks = 0